<app-dialog-heading [heading]="heading"></app-dialog-heading>
<div class="dialog-content">
  <form [formGroup]="notesFormGroup">
    <mat-form-field>
      <mat-label>Notes</mat-label>
      <textarea type="text" matInput [rows]="defaultRows"
                [formControlName]="Controls.Note"></textarea>
    </mat-form-field>
    <mat-icon [matTooltip]="'Add notes'" class="info-icon">help_outline</mat-icon>
  </form>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button color="primary" (click)="onClickSave()">Okay</button>
  <button class="dialog-button" mat-raised-button color="warn" (click)="onClickCancel()">Cancel</button>
</mat-dialog-actions>
